import React from 'react';
import type { WeakPointWithCommentary } from '../types';

const WeakPoints: React.FC<{ items: WeakPointWithCommentary[]; recommendation: string }> = ({ items, recommendation }) => (
  <section className="py-4 border-b border-slate-200">
    <div className="flex items-baseline justify-between mb-3 flex-wrap gap-2">
      <h3 className="text-[13px] font-semibold text-slate-900">改善ポイント詳細</h3>
      <span className="text-[11px] text-slate-500">各項目の重要性と改善後効果</span>
    </div>

    {items.length === 0 ? (
      <p className="text-[12px] text-slate-500 italic">特筆すべき弱点は検出されませんでした。</p>
    ) : (
      <div className="space-y-3">
        {items.map((item, i) => (
          <div key={i} className="border-l-2 border-leaf-300 pl-3">
            <div className="text-[12px] font-semibold text-slate-900 mb-1">
              <span className="text-leaf-700 mr-1">{i + 1}.</span>{item.text}
            </div>
            {item.commentary && (
              <p className="text-[12px] text-slate-600 leading-relaxed">{item.commentary}</p>
            )}
          </div>
        ))}
      </div>
    )}

    <div className="mt-4 pt-3 border-t border-slate-100">
      <h4 className="text-[11px] font-semibold text-leaf-800 mb-1">最優先施策（戦略提案）</h4>
      <p className="text-[12px] text-slate-700 leading-relaxed whitespace-pre-line">{recommendation}</p>
    </div>
  </section>
);

export default WeakPoints;
